import React from "react";
import { LoadingIndicator } from "@jsq/ds/core";
import StateTemplate from "./StateTemplate";

const LoadingState = () => {
  return (
    <StateTemplate
      title="Loading summary..."
      subTitle="This may be taking longer due to a big date range or a lot of transactions."
      icon={<LoadingIndicator size="large" />}
      delay={5000}
    />
  );
};

export default LoadingState;
